//console.log("[WebWorker]: init");

//setInterval(() => {
//    // console.log("web working trigger");
//    postMessage("CHECK_TOKEN_EXPIRATION");
//}, 1000);
